module.exports = __webpack_public_path__ + "static/media/Yenepoya-Photos-1.95fd6290.png";